import { PartyType } from "Api/Api";
import { usePartyQuery } from "Api/Queries/Party/usePartyQuery";
import type { PartyDto, RelatedPartyDto } from "Infrastructure/Api/Api";
import { isBusinessRelationType } from "Models/BusinessRelationTypes";

type ReturnValue = {
  partyRelation: RelatedPartyDto | undefined;
  actingPartyData: PartyDto | undefined;
  isLoading: boolean;
};

export const usePartyActingPersonParty = (partyID?: string): ReturnValue => {
  const { data: partyData, isLoading: isPartyLoading } = usePartyQuery(partyID);

  const partyRelation = partyData?.relatedParties?.find(({ relationType }) =>
    isBusinessRelationType(relationType),
  );

  const { data: actingPartyData, isLoading: isActingPersonPartyLoading } =
    usePartyQuery(partyRelation?.relatedPartyPublicID);

  if (isPartyLoading) {
    return {
      partyRelation: undefined,
      actingPartyData: undefined,
      isLoading: true,
    };
  }

  if (!partyData) {
    return {
      partyRelation: undefined,
      actingPartyData: undefined,
      isLoading: false,
    };
  }

  if (partyData.type !== PartyType.LegalEntity) {
    return {
      partyRelation: undefined,
      actingPartyData: partyData,
      isLoading: false,
    };
  }

  return {
    partyRelation,
    actingPartyData,
    isLoading: isPartyLoading || isActingPersonPartyLoading,
  };
};
